import * as serviceWorker from './serviceWorker';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Spin, Icon } from 'antd';

import configureStore from './app/store/configureStore';
import { verifyCredentials } from './app/authTokenConfig';
import Root from './app/containers/Root';

import 'antd/dist/antd.css';
import './index.css';
import './app.css'
const initialState = {
  reduxTokenAuth: {
    currentUser: {
      isSignedIn: false,
      attributes: {
        name: null,
        image: null,
        email: null
      },
    },
  }
};

const { store, persistor } = configureStore(initialState);
verifyCredentials(store);
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Spin indicator={<Icon type='loading' style={{ fontSize: 24 }} spin />} size='large' />} persistor={persistor}>
      <Root />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
